import { FC, ReactNode } from 'react';
import Icon from 'components/Icon';

interface BadgeCtaCardProps {
  icon: string;
  title: string;
  description: string;
  action: ReactNode;
}

export const BadgeCtaCard: FC<BadgeCtaCardProps> = ({ icon, title, description, action }) => (
  <div className="recipient-badges-card__cta-card">
    <Icon name={icon} size={28} />
    <span className="h4-text">{title}</span>
    <span className="body-small-text color-gray">{description}</span>
    {action}
  </div>
);
